import React from "react";
import "./ModalTextDisplay.scss";

const ModalTextDisplay = (props) => {
  return (
    <div className="modal-container">
        <p>{props.text}</p>
    </div>
  );
};

export default ModalTextDisplay;
